export default "__VITE_ASSET__DtAuF7Oh__"